import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import ChatList from "../components/ChatList";
import ChatRoom from "../components/ChatRoom";
import "./ChatPage.css";

const ChatPage: React.FC = () => {
  return (
    <div className="page-content chat-page">
      <Routes>
        <Route path="/" element={<ChatList />} />
        <Route path="/:chatRoomId" element={<ChatRoom />} />
      </Routes>
    </div>
  );
};

export default ChatPage;
